import styled from "styled-components";

// Segue o padrão dos demais modais do painel (ver CriarTipoContainer em
// ModalTiposVariacao/styles.ts): padding 3rem 5rem, título centralizado e
// texto de apoio em tertiary. Lembrar que :root usa font-size 6px em 1920px,
// então 1rem ≈ 6px — larguras de modal vão em px, não em rem.
export const ContainerModalEditarVariacao = styled.div`
  padding: 32px 24px;

  .titulo {
    text-align: center;
    color: ${(props) => props.theme.colors.primary};
    font-weight: bold;
    margin-bottom: 2rem;
  }

  .subtitulo {
    text-align: center;
    color: ${(props) => props.theme.colors.tertiary};
    margin-bottom: 5rem;

    strong {
      font-weight: 700;
    }
  }

  .campo {
    margin-bottom: 4rem;
  }

  .aviso {
    margin-top: 1rem;
    color: ${(props) => props.theme.colors.tertiary};
  }

  .pergunta {
    color: ${(props) => props.theme.colors.tertiary};
    margin-bottom: 2rem;
    text-align: left;
  }

  /* Mesma marcação do escopo de ajuste de preço do catálogo: label + radio
     nativo, estilizado pela classe global .input-radio. */
  .opcoes {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    margin-bottom: 4rem;
  }

  .opcao {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    cursor: pointer;
    color: ${(props) => props.theme.colors.tertiary};
  }

  /* Picker e campo Hex lado a lado. O ColorPicker é compartilhado com as cores
     da empresa, onde o layout é empilhado — então a mudança vive aqui, por
     estrutura, em vez de alterar o componente e mexer na tela de configurações.
     Filhos do ColorPickerContainer: [1] linha do Saturation + Hue, [2] HexInputContainer. */
  .color-wrapper {
    > div {
      display: flex;
      align-items: flex-start;
      gap: 3rem;

      /* Os DOIS filhos declaram width: 100% (o primeiro inline, o segundo no
         HexInputContainer). Em coluna isso era inofensivo; em linha cada um pede
         a largura inteira do modal e o Hex vaza pra fora. Por isso as duas
         larguras são neutralizadas aqui. */
      > div:first-child {
        width: auto !important;
        flex-shrink: 0;
        /* padding-bottom também vem inline, daí o !important. */
        padding-bottom: 0 !important;
      }

      > div:last-child {
        width: auto;
        flex: 1;
        min-width: 0;
        align-items: flex-start;

        .input-hex-container {
          width: 100%;
        }
      }
    }
  }

  /* Dropzone da foto — mesmo "wrapper dragging" das mídias do produto
     (ver .wrapper em Upload/imageUploadProduto/styles.ts): ícones de galeria e
     play sobrepostos à esquerda, texto à direita, tudo numa linha. */
  .upload-wrapper {
    /* O ImageUploadWithCrop renderiza um <label>, que é inline: sem isto ele
       encolhe pro conteúdo e espreme o dropzone inteiro. */
    .swatch-upload-label {
      display: block;
      width: 100%;
      cursor: pointer;
    }

    .swatch-dropzone {
      width: 100%;
      min-height: 16rem;
      border-radius: 20px;
      background-color: ${(props) => props.theme.colors.white};
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2rem;
      position: relative;
      cursor: pointer;

      > .icones {
        padding: 1rem;
        width: 12rem;
        height: 100%;
        min-height: 14rem;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 0;

        .galery-icon {
          width: 100%;
          position: absolute;
          z-index: 2;
          top: 0;
          bottom: 0;
          margin: auto 0;
          transition: 0.3s ease-in-out;
          transform: scale(0.5) translateY(-10%) translateX(-20%) rotate(355deg);
        }

        .galery-ativo {
          transform: scale(0.5) translateY(-15%) translateX(-35%) rotate(345deg);
        }

        /* O fundo aqui recorta o ícone de galeria que fica atrás, então precisa
           acompanhar o fundo da caixa (colors.white muda com o tema). */
        .play-icon {
          width: 100%;
          position: absolute;
          z-index: 2;
          top: 0;
          bottom: 0;
          margin: auto 0;
          background-color: ${(props) => props.theme.colors.white};
          transition: 0.3s ease-in-out;
          transform: scale(0.5) translateY(10%) translateX(20%) rotate(5deg);
        }

        .play-ativo {
          transform: scale(0.5) translateY(15%) translateX(35%) rotate(15deg);
        }
      }

      /* Grid em vez de flex:1 + absolute: assim o texto tem largura natural e
         fica colado no ícone, formando um bloco só centralizado na caixa.
         Os dois textos dividem a mesma célula para o crossfade de opacidade. */
      .texto-wrapper {
        display: grid;
        align-items: center;

        .texto {
          grid-area: 1 / 1;
          transition: 0.3s ease-in-out;
          color: ${(props) => props.theme.colors.tertiary};
          text-align: left;
          max-width: 22rem;
        }
      }

      .preview {
        width: 10rem;
        height: 10rem;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }

  .botoes {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    margin-top: 5rem;

    .cancelar {
      display: flex;
      align-items: center;
      gap: 1rem;
      cursor: pointer;
      color: ${(props) => props.theme.colors.tertiary};

      /* Mesmo tratamento do "Voltar" das outras telas (ver Categorias/styles.ts):
         sem fill o ícone fica preto e some no tema escuro. */
      svg {
        fill: ${(props) => props.theme.colors.primary};
        transform: rotate(90deg);
      }
    }
  }
`;

// Mesmas medidas do crop de categoria (ImageUploadCategoria/styles.ts), que é o
// caso equivalente: 1:1, circular e resize 150x150. Sem a largura fixa aqui o
// ReactCrop renderiza a imagem no tamanho natural — um upload 1920x1080 estoura a tela.
export const ModalCroppingContainer = styled.div`
  width: 65rem;
  max-width: 100%;
  padding: 0 2rem;

  .titulo {
    color: ${(props) => props.theme.colors.tertiary};
    text-align: left;
    padding: 2rem 0 0 2rem;
    font-weight: bold;
  }

  .botoes {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 0 0 2rem;

    .cancelar {
      cursor: pointer;
      margin-top: 0 !important;
      color: ${(props) => props.theme.colors.tertiary};
    }
  }
`;